import { Box } from '@material-ui/core';
import { Header } from '../../components';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

const ItemReport = () => {
  let hasMLSEOnlyStore:any = 'MLSEStoreType';
  let hasDDFOnlyStore:any = 'DubaiDutyFreeStoreType';
  const checkStoreTypes = () => {
    active_stores?.filter((store: any) => {
      if (store?.store_type !== 'MLSEStoreType') {
        hasMLSEOnlyStore = false;
      }
      if (store?.store_type !== 'DubaiDutyFreeStoreType') {
        hasDDFOnlyStore = false;
      }
    });
    return {
      MLSEStoreType: hasMLSEOnlyStore,
      DubaiDutyFreeStoreType: hasDDFOnlyStore,
    };
  };
  const active_stores = useSelector((state: any) => state.store.active_stores);
  return (
    <Box>
      <Header
        showStores={true}
        title={
          <FormattedMessage id="itemReport" defaultMessage="Item Report" />
        }
        rightAccessory={() => {
          return <></>;
        }}
      />

      <Box component="div">
        {() => {
          checkStoreTypes();
          switch (hasMLSEOnlyStore || hasDDFOnlyStore) {
            case 'MLSEStoreType':
              console.log('----MLSEStoreType');
              return (
                <iframe
                  width="100%"
                  height="800px"
                  src="https://lookerstudio.google.com/embed/reporting/9a7ca1a9-01cb-4554-8f26-589ac1b05808/page/kEYvD"
                  sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
                ></iframe>
              );
            case 'DubaiDutyFreeStoreType':
              console.log('----DubaiDutyFreeStoreType');
              return (
                <iframe
                  width="100%"
                  height="800px"
                  src="https://lookerstudio.google.com/embed/reporting/316be3a7-0df2-48b8-a8c6-0234f78e38c1/page/kEYvD"
                  sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
                ></iframe>
              );
            default:
              return (
                <div>
                  {' '}
                  <FormattedMessage
                    id="noReports"
                    defaultMessage="No Reports Available"
                  />
                </div>
              );
          }
        }}
      </Box>
    </Box>
  );
};

export default ItemReport;
